import Navbar from "../../../components/navbar";
import BlogItem from '../../../components/blog/item';
import Footer from '../../../components/footer';

import { data } from '../../../components/blog/data';

import { Link } from "react-router-dom";

const BlogGrid = () =>{
    return(
    <>
    <header
    className="container-fluid bg-primary headerExtra"
    id="home">
      <div
      className="container h-100">
      <Navbar />
        <div className="d-flex flex-column align-items-center justify-content-center h-75 text-white ">
          <h1 className="text-white display-4">
            Blog grid 02
          </h1>
          <div>
            <Link
            className="text-white mx-2"
            to="/home01">
              Home
            </Link>
              &#11166;
            <Link
            className="text-white mx-2 font"
            to="/blog01">
              Blog Grid
            </Link>
          </div>
        </div>
      </div>
    </header>
    <div className="container d-flex flex-column-reverse flex-md-row division2">
      <div className="col-12 d-flex flex-wrap">
        {
          data.map((e) =>(
            <div className="col-12 col-md-6 col-xl-4 my-3">
              <div className="row px-3">
                <BlogItem
                title={e.title}
                img={e.thumbnail}
                />
              </div>
            </div>
          ))
        }
      </div>
    </div>
    <nav className="d-flex justify-content-center division2">
      <ul className="pagination pagination-md-lg">
        <li className="page-item">
          <Link
          className="page-link"
          aria-label="previous">
            <span aria-hidden="true">
              &laquo;
            </span>
            <span className="sr-only">
              previous
            </span>
          </Link>
        </li>
        <li className="page-item">
          <Link className="page-link">1</Link>
        </li>
        <li
        class="page-item">
          <Link className="page-link">2</Link>
        </li>
        <li className="page-item">
          <Link className="page-link">3</Link>
        </li>
        <li className="page-item">
          <Link
          className="page-link"
          aria-label="next">
            <span aria-hidden="true">
              &raquo;
            </span>
            <span className="sr-only">
              next
            </span>
          </Link>
        </li>
      </ul>
    </nav>
    <Footer />
    </>
  )
};
export default BlogGrid;